import React from 'react';
import './500.scss';
import { observer } from 'mobx-react';
import '../../styles/globals.scss';
import '../../features/pre-auth/login/login.scss';

interface IProps {
    error: any,
    info: any,
}

interface IState {
}

@observer
export class Error500 extends React.Component<IProps, IState> {
    public constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className="pufferfish-500">
                <div className="logo" />
                <div className="header">
                    Sorry, but it appears an error has occurred.
                </div>
                <div className="sub-header">
                    Our team has been notified and will follow up when the issue has been resolved.
                </div>
            </div>
        );
    }

}
